/** Strip accents and lowercase for accent-insensitive comparison. */
export const norm = (s: any): string =>
  String(s ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

/** Accent-insensitive includes match. */
export const fuzzyIncludes = (haystack: any, needle: string): boolean =>
  norm(haystack).includes(norm(needle));
